import { render } from "./Banking.vue?vue&type=template&id=7b939f88&scoped=true&ts=true"
import script from "./Banking.vue?vue&type=script&lang=ts"
export * from "./Banking.vue?vue&type=script&lang=ts"

import "./Banking.vue?vue&type=style&index=0&id=7b939f88&scoped=true&lang=css"

import exportComponent from "/home/lahiru-dhananjaya/Documents/Jeewaka/PMS/Source and Documentation/pharma-connect2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b939f88"]])

export default __exports__